module.exports = __webpack_public_path__ + "static/favicon-196x196-fb4260891e2b8febe6fb72445fcdec99.png";